<template>
  <button v-if="buttonStyle == 0" type="button" class="btn btn-primary" @click="showModal()"><font-awesome-icon icon="plus" /> Neues Unternehmen</button>

  <button v-else-if="buttonStyle == 1" type="button" class="btn btn-primary w-100" @click="showModal()">
    <font-awesome-icon icon="plus" class="me-2" /> Neues Unternehmen hinzufügen
  </button>

  <button v-else type="button" class="btn btn-primary btn-sm" title="Unternehmen bearbeiten" @click="showModal()">
    <font-awesome-icon icon="pen" />
  </button>

  <!-- Edit UnternehmenModal -->
  <div
    class="modal fade"
    :id="'editUnternehmenModal' + index"
    tabindex="-1"
    :aria-labelledby="'editUnternehmenModal' + index"
    aria-hidden="true"
    ref="editUnternehmenModalRef"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary py-2" data-bs-theme="dark">
          <span v-if="editUnternehmen.id == 0" class="modal-title my-auto text-white" :id="'editUnternehmenModalLabel' + index">Neue Unternehmen</span>

          <span v-else class="modal-title my-auto text-white" :id="'editUnternehmenModalLabel' + index">Unternehmen bearbeiten</span>

          <button type="button" class="btn-close btn-sm" @click="closeModal()"></button>
        </div>

        <div class="modal-body" :id="'editUnternehmenModalBody' + index">
          <LoadingSpinner v-if="loading" />

          <form v-else @submit.prevent="saveUnternehmen">
            <div class="mb-3">
              <label :for="'unternehmenTitel-' + index" class="form-label fw-bold">Titel</label>
              <input type="text" class="form-control" :id="'unternehmenTitel-' + index" v-model="editUnternehmen.titel" />
            </div>

            <div class="mb-3">
              <label :for="'unternehmenRealm-' + index" class="form-label fw-bold">Realm</label>
              <input type="text" class="form-control" :id="'unternehmenRealm-' + index" v-model="editUnternehmen.realm" :disabled="editUnternehmen.id !== 0" />
            </div>

            <hr class="my-3" />

            <div class="mb-3">
              <label :for="'unternehmenArchivApiUrl-' + index" class="form-label fw-bold">Archiv API URL</label>
              <input type="text" class="form-control" :id="'unternehmenArchivApiUrl-' + index" v-model="editUnternehmen.archivApiUrl" />
            </div>

            <div class="mb-3">
              <label :for="'unternehmenArchivApiKey-' + index" class="form-label fw-bold">Archiv API Key</label>
              <input type="text" class="form-control" :id="'unternehmenArchivApiKey-' + index" v-model="editUnternehmen.archivApiKey" />
            </div>

            <hr class="my-3" />

            <div v-if="errorMsg != ''" class="alert alert-danger mb-3">
              Es ist ein Fehler aufgetreten:<br />
              {{ errorMsg }}
            </div>

            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-secondary me-3" @click="closeModal()">Abbrechen</button>
              <button type="submit" class="btn btn-primary">Speichern</button>
            </div>
          </form>
        </div>

        <div v-if="!loading && editUnternehmen.id != 0" class="modal-footer justify-content-start">
          <button type="button" class="btn btn-danger" @click="deleteUnternehmen()"><font-awesome-icon icon="trash" /> Unternehmen löschen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed, ref } from 'vue';
  import { Modal } from 'bootstrap';

  import { useUnternehmenStore } from '@/stores/unternehmenStore';
  import { useCommonStore } from '@/stores/commonStore';
  // import { useAuthStore } from '@/stores/authStore';

  import { Unternehmen } from '@/models/UnternehmenModels';

  import LoadingSpinner from '../LoadingSpinner.vue';
  //#endregion

  const props = defineProps({
    unternehmen: {
      type: Object as PropType<Unternehmen>,
      default: new Unternehmen(),
    },

    index: {
      type: Number as PropType<number>,
      required: true,
    },

    buttonStyle: {
      type: Number as PropType<number>,
      default: 0, // 0 = erstellen; 1 = bearbeiten
    },
  });

  const emits = defineEmits(['deleteUnternehmen']);

  // const authStore = useAuthStore();
  const unternehmenStore = useUnternehmenStore();
  const commonStore = useCommonStore();

  const loading = computed(() => commonStore.status.createUnternehmenLoading || commonStore.status.updateUnternehmenLoading);
  const errorMsg = computed(() => commonStore.status.unternehmenErrorMsg);

  const editUnternehmen = ref(JSON.parse(JSON.stringify(props.unternehmen)) as Unternehmen);

  function saveUnternehmen() {
    editUnternehmen.value.titel = editUnternehmen.value.titel.trim();

    if (editUnternehmen.value.id !== 0) {
      unternehmenStore.updateUnternehmen(editUnternehmen.value).then(() => {
        if (errorMsg.value == '') {
          closeModal();
        }
      });
    } else {
      // editUnternehmen.value.userId = authStore.kc.tokenParsed?.sub || '';

      unternehmenStore.createUnternehmen(editUnternehmen.value).then(() => {
        if (errorMsg.value == '') {
          closeModal();
        }
      });
    }
  }

  function deleteUnternehmen() {
    closeModal();
    emits('deleteUnternehmen', props.unternehmen);
  }

  //#region Modal
  const editUnternehmenModalRef = ref();

  function closeModal() {
    Modal.getInstance(editUnternehmenModalRef.value)?.hide();
  }

  function showModal() {
    if (editUnternehmenModalRef.value) {
      editUnternehmen.value = JSON.parse(JSON.stringify(props.unternehmen)) as Unternehmen;

      new Modal(editUnternehmenModalRef.value).show();
    }
  }
  //#endregion
</script>

<style scoped>
  .modal-content {
    background: rgb(242, 243, 248);
  }

  /* .modal-body {
  background: rgb(242, 243, 248);
}

.modal-footer {
  background: rgb(242, 243, 248);
} */
</style>
